import { Stack } from '@mui/material';
import { t } from 'i18next';

import { ConctractListResponse } from '../../../services/types/contractListResponse';
import { InternalContract } from '../../BaseController/types/internalContract';
import { InfoBox } from '../../infoBox/infoBox';
import { ContractCard } from './contractCard';
import { ContractCardSkeleton } from './contractCardSkeleton';

export interface ContractCardsProps {
  isLoading: boolean;
  mappingFunc: (contract: ConctractListResponse) => InternalContract[];
  contractList: ConctractListResponse;
}

export const ContractCards = ({
  isLoading,
  mappingFunc,
  contractList,
}: ContractCardsProps) => {
  if (isLoading) {
    return (
      <>
        <ContractCardSkeleton />
        <ContractCardSkeleton />
        <ContractCardSkeleton />
        <ContractCardSkeleton />
        <ContractCardSkeleton />
        <ContractCardSkeleton />
        <ContractCardSkeleton />
      </>
    );
  }

  if (contractList.contracts.length > 0) {
    const result = mappingFunc(contractList).map((data: any) => (
      <ContractCard key={data.contractNr + data.contractPosition} data={data} />
    ));
    return <Stack spacing={1}>{result}</Stack>;
  }

  return <InfoBox infoHeader={t('NoMatchingResults')} />;
};
